/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_Position_DescInputs */

const en_caption_position_desc = /** @type {(inputs: Caption_Position_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change caption position of selected events`)
};

const fr_caption_position_desc = /** @type {(inputs: Caption_Position_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier la position des événements sélectionnés`)
};

const de_caption_position_desc = /** @type {(inputs: Caption_Position_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändern Sie die Untertitelposition der ausgewählten Ereignisse`)
};

const it_caption_position_desc = /** @type {(inputs: Caption_Position_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia la posizione della didascalia degli eventi selezionati`)
};

const ru_caption_position_desc = /** @type {(inputs: Caption_Position_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменить позицию подписи выбранных событий`)
};

const es_caption_position_desc = /** @type {(inputs: Caption_Position_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar la posición de subtítulos de los eventos seleccionados`)
};

const zh_cn2_caption_position_desc = /** @type {(inputs: Caption_Position_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更改所选事件的标题位置`)
};

const ja_caption_position_desc = /** @type {(inputs: Caption_Position_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントのキャプション位置を変更する`)
};

const hi_caption_position_desc = /** @type {(inputs: Caption_Position_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित इवेंट्स की कैप्शन स्थिति बदलें`)
};

const pt_pt2_caption_position_desc = /** @type {(inputs: Caption_Position_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterar a posição da legenda dos eventos selecionados`)
};

/**
* | output |
* | --- |
* | "Change caption position of selected events" |
*
* @param {Caption_Position_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_position_desc = /** @type {((inputs?: Caption_Position_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_Position_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_caption_position_desc(inputs)
	if (locale === "de") return de_caption_position_desc(inputs)
	if (locale === "it") return it_caption_position_desc(inputs)
	if (locale === "ru") return ru_caption_position_desc(inputs)
	if (locale === "es") return es_caption_position_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_caption_position_desc(inputs)
	if (locale === "ja") return ja_caption_position_desc(inputs)
	if (locale === "hi") return hi_caption_position_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_caption_position_desc(inputs)
	return en_caption_position_desc(inputs)
});